module.exports = __webpack_public_path__ + "img/icon-alert-circle.c9d2057c.svg";